import React from "react";
import {X} from "lucide-react";

interface DiscordWidgetProps {
  isOpen: boolean;
  onClose: () => void;
}

const DiscordWidget: React.FC<DiscordWidgetProps> = ({isOpen, onClose}) => {
  if (!isOpen) return null;

  return (
    <div className="env-blanket-overlay" onClick={onClose}>
      <div className="discord-modal" onClick={(e) => e.stopPropagation()}>
        <div className="discord-modal-header">
          <h3>Join Our Discord</h3>
          <button className="discord-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="discord-modal-content">
          <iframe
            src="https://discord.com/widget?id=1265203619930701905&theme=dark"
            width="350"
            height="500"
            allowTransparency={true}
            frameBorder="0"
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
            title="League of Fabled Pursuits Discord"
          />
        </div>
      </div>
    </div>
  );
};

export default DiscordWidget;
